import { createContext, useContext, useEffect } from "react";

/**
 * Input paths of the enclosing agent-context form that hold secrets. Paths are never removed, so a secret stays
 * redacted after its field is hidden while its value remains in the form state.
 */
export const AgentFormSecretInputsContext = createContext<Set<string> | undefined>(undefined);

/** Marks a form input as secret so its value is redacted from the agent UI context. */
export function useAgentFormSecretInput(name: string, isSecret: boolean) {
	const secretInputs = useContext(AgentFormSecretInputsContext);
	useEffect(() => {
		if (isSecret) secretInputs?.add(name);
	}, [secretInputs, name, isSecret]);
}
